import { CONNECTION } from "../../config/Connections";
import { CONFIG_ } from "../../config/Config";
import { successnotify, warningnotify } from "../../components/ToasNotif/Toast";
import { __openModal } from "../Modal";

var get = "/siswa-personalinfo";
var post = "/siswa-personalinfo";
export const actGetDataPersonalInfoSiswa = (id, filter = "student") => {
  return (dispatch) => {
    let config = CONFIG_({
      url: get + "/" + id + "?filter=" + filter,
      method: "GET",
    });
    dispatch({ type: "LOADING_PERSONALINFOSISWA" });
    CONNECTION(config)
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_PERSONALINFOSISWA",
            message: "Success get data",
            data: data,
            code: status,
          });
        }
        return dispatch({ type: "ERROR_PERSONALINFOSISWA", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_PERSONALINFOSISWA",
          message: "Network error..",
        });
      });
  };
};

export const actPostDataPersonalInfoSiswa = (params) => {
  return (dispatch) => {
    const { siswa } = params;
    let config = CONFIG_({ url: post, data: params, method: "POST" });
    dispatch({ type: "LOADING_PERSONALINFOSISWA" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Relative information has been create");
          dispatch(
            __openModal({ modal: "MODAL_ADD_TYPEFAMILYSISWA", open: false })
          );
          return dispatch(actGetDataPersonalInfoSiswa(siswa));
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_PERSONALINFOSISWA", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_PERSONALINFOSISWA",
          message: "Network error..",
        });
      });
  };
};

export const actUpdateDataPersonalInfoSiswa = (params) => {
  return (dispatch) => {
    const { id, siswa } = params;
    let config = CONFIG_({ url: post + "/" + id, data: params, method: "PUT" });
    dispatch({ type: "LOADING_PERSONALINFOSISWA" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Relative information has been update");
          dispatch(
            __openModal({ modal: "MODAL_EDIT_TYPEFAMILYSISWA", open: false })
          );
          return dispatch(actGetDataPersonalInfoSiswa(siswa));
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_PERSONALINFOSISWA", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_PERSONALINFOSISWA",
          message: "Network error..",
        });
      });
  };
};

export const actDetailDataPersonalInfoSiswa = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "GET" });
    dispatch({ type: "LOADING_PERSONALINFOSISWA" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_PERSONALINFOSISWA",
            message: "Success get data",
          });
        }
        return dispatch({ type: "ERROR_PERSONALINFOSISWA", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_PERSONALINFOSISWA",
          message: "Network error..",
        });
      });
  };
};

export const actDeleteDataPersonalInfoSiswa = (params) => {
  return (dispatch) => {
    const { id, siswa } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "DELETE" });
    dispatch({ type: "LOADING_PERSONALINFOSISWA" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Relative information has been deleted");
          return dispatch(actGetDataPersonalInfoSiswa(siswa));
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_PERSONALINFOSISWA", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_PERSONALINFOSISWA",
          message: "Network error..",
        });
      });
  };
};
